import { useTranslation } from "react-i18next";
import { cn } from "@/core/helpers/cn";
import useAppSelector from "@/core/helpers/useAppSelector";
import { ActionButton } from "@/shared/ui";
import {
  activeSpawnTypeSelector,
  hoverSpawnTypeSelector,
  spawnTypesSelector,
} from "@/domains/spawn/slice";
import useHandlers from "@/domains/spawn/hooks/useHandlers.ts";

type Props = {
  className?: string;
};

export default function SpawnListLocationsContainer({ className }: Props) {
  const { t } = useTranslation("spawn");
  const spawnTypes = useAppSelector(spawnTypesSelector);
  const hoverSpawnType = useAppSelector(hoverSpawnTypeSelector);
  const activeSpawnType = useAppSelector(activeSpawnTypeSelector);
  const { setActiveSpawnHandler, setHoverSpawnHandler } = useHandlers();

  return (
    <div className={cn("flex items-center gap-1.5", className)}>
      {spawnTypes.map((spawnType, index) => (
        <ActionButton
          key={spawnType}
          isActive={spawnType === hoverSpawnType || spawnType === activeSpawnType}
          action={String(index + 1)}
          label={t(`spawn.types.${spawnType}`)}
          onClick={() => setActiveSpawnHandler(spawnType)}
          onHover={() => setHoverSpawnHandler(spawnType)}
        />
      ))}
    </div>
  );
}
